import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import React from "react";
import { Link } from "react-router-dom";

const ITEM_HEIGHT = 48;

class LongMenu extends React.Component {
  constructor(props) {
    super(props);
    const { contractStage } = this.props;
    this.state = {
      anchorEl: null,
      editable: this.props.contractStage
        ? this.props.contractStage === "Agreed" ||
          this.props.contractStage === ""
        : true
    };
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  manageDeleteClick = () => {
    this.props.forDelete(this.props.currentId, this.props.columnData);
    this.handleClose();
  };

  manageEditClick = () => {
    console.log(this.props.contractStage);
    this.props.forEdit(
      this.props.currentId,
      this.props.columnData,
      this.props.contractStage,
      this.state.editable
    );
    this.handleClose();
  };

  manageChangePasswordClick = () => {
    console.log(this.props.contractStage);
    this.props.forChangePassword(
      this.props.currentId,
      this.props.columnData,
      this.props.contractStage,
      this.state.editable
    );
    this.handleClose();
  };

  render() {
    const { anchorEl, editable } = this.state;
    const open = Boolean(anchorEl);

    return (
      <div>
        <IconButton
          aria-label="More"
          aria-owns={open ? "long-menu" : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: 200
            }
          }}
        >
          {this.props.forEdit && (
            <Link
              to={editable ? `/${this.props.location}` : "#"}
              style={{ outline: "none" }}
            >
              <MenuItem onClick={this.manageEditClick}>Edit</MenuItem>
            </Link>
          )}
          {this.props.forChangePassword && (
            <Link
              to={this.props.changePasswordLocation ? `/${this.props.changePasswordLocation}` : "#"}
              style={{ outline: "none" }}
            >
              <MenuItem onClick={this.manageChangePasswordClick}>Change Password</MenuItem>
            </Link>
          )}
          {this.props.forDelete && (
            <MenuItem onClick={this.manageDeleteClick}>Delete</MenuItem>
          )}
        </Menu>
      </div>
    );
  }
}

export default LongMenu;



// WEBPACK FOOTER //
// ./src/components/LongMenu.js